import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Home, User } from '@lmc/ts-common'
import { mixpanel } from '../common/services/analytics'

const routes: string[] = [
		'/rota/builder',
		'/rota/monitoring',
		'/rota/patterns',
]

const useMixpanelEventsForRoutes = () => {
	const location = useLocation()
	
	const home = useSelector(
		(state: { global: { home: Home } }) => state.global.home
	)
	const user = useSelector(
		(state: { global: { user: User } }) => state.global.user
	)

	useEffect(() => {
		const currentPath = location.pathname

		const matchingRoute = routes.find(route => {
			return currentPath.startsWith(route)
		})

		if (matchingRoute) {
			mixpanel.track("Page visited", {
				path: currentPath,
				homeName: home?.name || 'Unknown Home',
				homeId: home?.id || 'Unknown Home',
				userId: user?.id || 'Unknown User',
				userName: `${user?.name.first} ${user?.name.last}` || 'Unknown User',
				pathname: currentPath,
			})
		}
	}, [location.pathname, routes, home?.name, home?.id])
}

export default useMixpanelEventsForRoutes